import React, {useEffect, useState} from 'react'
import hotspotSvgDefault from 'hotspots/hotspot2.svg'
import hotspotSvgYellow from 'hotspots/hotspot_yellow.svg'
import hotspotSvgLufthansa from 'hotspots/hotspot_lufthansa.svg'
import hotspotSvgRed from 'hotspots/hotspot_red.svg'
import hotspotSvgOekolab from 'hotspots/hotspot_okelab.svg'
import hotspotSvgFlavewingsforlife21 from 'hotspots/hotspot_red_flavewingsforlife21.svg'
import times from 'hotspots/times.svg'
import classNames from "classnames";
import {useSelector} from "react-redux";
import _ from "lodash";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import RenderedHtmlContent from './rendered_html_content'


export function Hotspot({
                          isEventBooth,
                          hotspot,
                          hotspotConfig,
                          onHotspotClick,
                          elementDetails,
                          setHoveredHotspotId,
                          refsArray,
                          dotted,
                          showHiddenHotspots
                        }) {
  const isBoothEditor = useSelector(state => state.isBoothEditor)
  const slideshowImages = useSelector(state => state.imageHotspotSlideshowImages.filter(si => si.image_hotspot_id == hotspot?.id))
  const [currentSlideshowImageIndex, setCurrentSlideshowImageIndex] = useState(0)
  const currentSlideshowImage = _.sortBy(slideshowImages, ["position", "id"], ["asc", "asc"])[currentSlideshowImageIndex]
  // const [hoveredHotspot, hoverHotspot] = useState(null)
  const hostname = useSelector(state => state.hostname)

  const tagOwner = useSelector(state => state.tagOwner)
  const guestListEntries = useSelector(state => state.guestListEntries)
  const events = useSelector(state => state.events)
  const placeholders = {tagOwner: tagOwner, guestListEntries: guestListEntries, events: events}

  let hotspotSvg = hostname == "flaveiot20" ? hotspotSvgRed : (hostname == "flavewingsforlife21" ? hotspotSvgFlavewingsforlife21 : (hostname == "flaveict21" ? hotspotSvgRed : (hostname == "flaveoekolab21" ? hotspotSvgOekolab : hotspotSvgDefault)))

  if (hostname === "flavekapschsummit21" || hostname === "flavepalfinger20") {
    hotspotSvg = hotspotSvgYellow
  } else if (hostname === "flavelufthansa23") {
    hotspotSvg = hotspotSvgLufthansa
  }

  const useMobileHotspots = useSelector(state => state.useMobileHotspots) !== false // So we can disable mobile hotspot rendering (needed for ringana)
  const isMobileByMediaQuery = useMediaQuery('(max-width:768px)');
  const isInternetExplorer = useMediaQuery('(min-width:0\\0)');

  useEffect(() => {
    if (hotspot.kind === "slideshow") {
      const interval = setInterval(() => {
        setCurrentSlideshowImageIndex(slideshowImages ? (((currentSlideshowImageIndex || 0) + 1) % slideshowImages.length) : 0)
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [hotspot, currentSlideshowImageIndex]);

  const isPresent = (value) => {
    return value != null && value != undefined && value != ""
  }

  let backgroundImage = null

  if (isInternetExplorer) {
    backgroundImage = null; // Do not set for IE
  } else if (hostname == "flaveiot20" || hostname == "flavenovonordisk21" || hostname == "flavegoldhasen21") {
    backgroundImage = `url("${isPresent(hotspot.hotspot_image?.url) ? hotspot.hotspot_image.url : hotspotSvg}")`
  } else if (hotspot.visibility_type === "image") {
    let hotspotImagePaths = []

    // This must happen before, that is why this is done so oddly.
    // The reason is that the hotspot animation image must appear first so it will be displayed above the hotspot image.
    if (!hotspot.disable_hotspot_animation || !hotspot.hotspot_image?.url || (isMobileByMediaQuery && !hotspot.mobile_hotspot_image?.url)) {
      hotspotImagePaths = [...hotspotImagePaths, hotspotSvg]
    }

    if (isMobileByMediaQuery && hotspot.mobile_hotspot_image?.url) {
      hotspotImagePaths = [...hotspotImagePaths, hotspot.mobile_hotspot_image?.url]
    } else if (hotspot.hotspot_image?.url) {
      hotspotImagePaths = [...hotspotImagePaths, hotspot.hotspot_image.url]
    }

    backgroundImage = hotspotImagePaths.map((imageUrl) => `url("${imageUrl}")`).join(", ")
  } else {
    backgroundImage = `url("${hotspotSvg}")`
  }


  const getErrorField = (msg) => {
    return <div className="badge badge-danger" style={{whiteSpace: "pre-wrap"}}>{msg}</div>
  };

  /**
   * For now only used to convert a normal youtube url to an embedded url.
   * Checks if its a youtube link and checks that the link does not include embed.
   * Then it will be converted.
   */
  const convertUrl = (url) => {
    if (url && (url.startsWith("https://www.youtube.com") || url.startsWith("https://youtube.com")) && !url.includes("embed/")) {
      return url.replace("watch?v=", "embed/")
    }
    return url
  }

  const getHotspotVisual = () => {
    if (hotspot.kind === "hidden") {
      return <div
        className={`hotspot-image-inner-none`}
        style={{
          width: "100%",
          backgroundImage: `url("${times}")`,
          backgroundPosition: "center center",
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          position: "relative",
          height: "100%",
          display: "block",
          cursor: "pointer"
        }}>
      </div>
    }

    if (hotspot.visibility_type === "inline_html" && hotspot.data.hotspot_inline_html) {
      const handleHotspotClick = () => {
        onHotspotClick(hotspot, currentSlideshowImage, hotspotConfig)
      }
      return (!isMobileByMediaQuery || !useMobileHotspots) &&
        <RenderedHtmlContent html={hotspot.data.hotspot_inline_html} placeholders={placeholders} handleHotspotClick={handleHotspotClick}/>
    } else if (hotspot.kind === "video") {


      if (!isPresent(hotspot.data.video_url)) {
        return getErrorField("No Video URL present!")
      }

      const videoUrl = convertUrl(hotspot.data.video_url)

      return <div className={"youtube-aspect-ratio hotspot-image-inner-video"}
                  style={{
                    cursor: isEventBooth ? "pointer" : "auto"
                  }}>
        {(!isMobileByMediaQuery || !useMobileHotspots) && <iframe
          style={{
            width: "100%",
            pointerEvents: isEventBooth ? "none" : "auto"
          }}
          width={elementDetails[hotspot.id] && elementDetails[hotspot.id].width ? elementDetails[hotspot.id].width : 0}
          height={elementDetails[hotspot.id] && elementDetails[hotspot.id].height ? elementDetails[hotspot.id].height : 0}
          src={videoUrl}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />}
      </div>
    } else if (hotspot.kind === "inline_html") {
      return (!isMobileByMediaQuery || !useMobileHotspots) &&
        <RenderedHtmlContent html={hotspot.data.inline_html} placeholders={placeholders}/>
    } else if (hotspot.kind === "slideshow") {
      if (!isPresent(currentSlideshowImage?.url)) {
        return getErrorField("No slideshow image present!")
      }
      return <div
        className={`hotspot-image-inner-slideshow`}
        style={{
          width: "100%",
          backgroundImage: `url("${currentSlideshowImage?.url}")`,
          backgroundPosition: "center center",
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          position: "relative",
          height: "100%",
          display: "block",
          cursor: "pointer"
        }}>
      </div>
    } else if (hotspot.visibility_type === "image") {
      if (!isPresent(hotspot.hotspot_image?.url)) {
        console.log("hotspot", hotspot)
        return getErrorField("No image present!")
      }
      //let backgroundImage = hovered && hotspot.hover_image?.url ? `url("${isPresent(hotspot.hover_image?.url) ? hotspot.hover_image.url : hotspotSvg}")` : ` url("${hotspotSvg}"), url("${isPresent(hotspot.hotspot_image?.url) ? hotspot.hotspot_image.url : hotspotSvg}")`
      return <div
        className={`hotspot-image-inner-image`}
        style={{
          width: "100%",
          backgroundImage: backgroundImage,
          backgroundPosition: "center center",
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          position: "relative",
          height: "100%",
          display: "block",
          cursor: "pointer"
        }}>
      </div>
    } else if (hotspot.visibility_type === "hidden") {
      return <div
        className={`hotspot-image-inner-hidden`}
        style={{
          width: "100%",
          backgroundPosition: "center center",
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          position: "relative",
          height: "100%",
          display: "block",
          cursor: "pointer"
        }}>
      </div>
    }

    //let backgroundImage = hovered && hotspot.hover_image?.url ? `url("${isPresent(hotspot.hover_image?.url) ? hotspot.hover_image.url : hotspotSvg}")` : ` url("${hotspotSvg}"), url("${isPresent(hotspot.hotspot_image?.url) ? hotspot.hotspot_image.url : hotspotSvg}")`
    return <div
      className={`hotspot-image-inner-default`}
      style={{
        width: "100%",
        backgroundImage: backgroundImage,
        backgroundPosition: "center center",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        position: "relative",
        height: "100%",
        display: "block",
        cursor: "pointer"
      }}>
    </div>
  }

  const getHotspotMobileContent = () => {

    if (hotspot.kind === "hidden") {
      // return <div
      //   className={`hotspot-image-inner-none`}
      //   style={{
      //     width: "100%",
      //     backgroundImage: `url("${times}")`,
      //     backgroundPosition: "center center",
      //     backgroundSize: "contain",
      //     backgroundRepeat: "no-repeat",
      //     position: "relative",
      //     height: "100%",
      //     display: "block",
      //     cursor: "pointer"
      //   }}>
      // </div>
    } else if (hotspot.visibility_type === "inline_html" && hotspot.data.hotspot_inline_html) {
        const handleHotspotClick = () => {
          onHotspotClick(hotspot, currentSlideshowImage, hotspotConfig)
        }
        return (isMobileByMediaQuery && useMobileHotspots) &&
          <RenderedHtmlContent html={hotspot.data.hotspot_inline_html} placeholders={placeholders} handleHotspotClick={handleHotspotClick}/>
    } else if (hotspot.kind === "video") {

      if (!isPresent(hotspot.data.video_url)) {
        return getErrorField("No Video URL present!")
      }

      const videoUrl = convertUrl(hotspot.data.video_url)

      return <div className={"youtube-aspect-ratio hotspot-image-inner-mobile-video"}
                  style={{
                    cursor: isEventBooth ? "pointer" : "auto"
                  }}>
        {(isMobileByMediaQuery && useMobileHotspots) && <iframe
          style={{
            width: "100%",
            pointerEvents: isEventBooth ? "none" : "auto"
          }}

          //makes no sense, no position or widths available on mobile rendering
          //width={elementDetails[hotspot.id] && elementDetails[hotspot.id].width ? elementDetails[hotspot.id].width : 0}
          //height={elementDetails[hotspot.id] && elementDetails[hotspot.id].height ? elementDetails[hotspot.id].height : 0}

          src={videoUrl}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen/>}
      </div>
    } else if (hotspot.kind === "inline_html") {
      return (isMobileByMediaQuery && useMobileHotspots) &&
        <RenderedHtmlContent html={hotspot.data.inline_html} placeholders={placeholders}/>
    } else if (hotspot.kind === "slideshow") {
      if (!isPresent(currentSlideshowImage?.url)) {
        return getErrorField("No slideshow image present!")
      }
      return <div
        className={`hotspot-image-inner-mobile-slideshow`}
        style={{
          width: "100%",
          backgroundImage: `url("${currentSlideshowImage?.url}")`,
          backgroundPosition: "center center",
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          position: "relative",
          height: "150px",
          display: "block",
          cursor: "pointer"
        }}>
      </div>
    } else if (hotspot.visibility_type === "image" && hotspot.mobile_hotspot_image?.url) {
      if (!isPresent(hotspot.hotspot_image?.url)) {
        console.log("hotspot", hotspot)
        return getErrorField("No image present!")
      }
      return <div
        className={`hotspot-image-inner-mobile-slideshow`}
        style={{
          width: "100%",
          backgroundImage: `url("${hotspot.mobile_hotspot_image?.url}")`,
          backgroundPosition: "center center",
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          position: "relative",
          height: "150px",
          display: "block",
          cursor: "pointer"
        }}>
      </div>
    } else if (hotspot.kind === "redirect") {
      return <div className={"hotspot-image-inner-mobile"}>
        <RenderedHtmlContent html={hotspot.data?.title || hotspot.data?.redirect_url || "Click to view"}/>

      </div>
    } else if (hotspot.visibility_type === "hidden") {
      // return <div
      //   className={`hotspot-image-inner-hidden`}
      //   style={{
      //     width: "100%",
      //     backgroundPosition: "center center",
      //     backgroundSize: "contain",
      //     backgroundRepeat: "no-repeat",
      //     position: "relative",
      //     height: "100%",
      //     display: "block",
      //     cursor: "pointer"
      //   }}>
      // </div>
    }

    // return <div
    //   className={`hotspot-image-inner-default`}
    //   style={{
    //     width: "100%",
    //     backgroundImage: `url("${hotspotSvg}")`,
    //     backgroundPosition: "center center",
    //     backgroundSize: "contain",
    //     backgroundRepeat: "no-repeat",
    //     position: "relative",
    //     height: "100%",
    //     display: "block",
    //     cursor: "pointer"
    //   }}>
    // </div>

    return <div className={"hotspot-image-inner-mobile"}>
      <RenderedHtmlContent html={hotspot.data?.title || "Click to view"}/>
    </div>
  }

  const getInternetExplorerHotspotVisual = () => {
    const width = elementDetails[hotspot.id] && elementDetails[hotspot.id].width ? elementDetails[hotspot.id].width : 0
    const height = elementDetails[hotspot.id] && elementDetails[hotspot.id].height ? elementDetails[hotspot.id].height : 0
    const widthHeight = Math.min(width, height)
    const marginLeft = (width - widthHeight) / 2
    const marginTop = (height - widthHeight) / 2

    const internetExplorerRipple = <div className="hotspot-ripple-outer"
                                        style={{
                                          width: `${widthHeight}px`,
                                          height: `${widthHeight}px`,
                                          marginLeft: `${marginLeft}px`,
                                          marginTop: `${marginTop}px`
                                        }}>
      <div className="hotspot-ripple-inner">
        <div/>
        <div/>
      </div>
    </div>


    if (hotspot.kind === "hidden") {
      return <div
        className={`hotspot-image-inner-none`}
        style={{
          width: "100%",
          backgroundImage: `url("${times}")`,
          backgroundPosition: "center center",
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          position: "relative",
          height: "100%",
          display: "block",
          cursor: "pointer"
        }}>
      </div>
    }

    if (hotspot.kind === "video") {
      if (!isPresent(hotspot.data.video_url)) {
        return getErrorField("No Video URL present!")
      }

      const videoUrl = convertUrl(hotspot.data.video_url)

      return <div className={"youtube-aspect-ratio hotspot-image-inner-video"}
                  style={{
                    cursor: isEventBooth ? "pointer" : "auto"
                  }}>
        {(!isMobileByMediaQuery || !useMobileHotspots) && <iframe
          style={{
            width: "100%",
            pointerEvents: isEventBooth ? "none" : "auto"
          }}
          width={elementDetails[hotspot.id] && elementDetails[hotspot.id].width ? elementDetails[hotspot.id].width : 0}
          height={elementDetails[hotspot.id] && elementDetails[hotspot.id].height ? elementDetails[hotspot.id].height : 0}
          src={videoUrl}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen/>}
      </div>
    } else if (hotspot.kind === "slideshow") {
      if (!isPresent(currentSlideshowImage?.url)) {
        return getErrorField("No slideshow image present!")
      }
      return <div
        className={`hotspot-image-inner-slideshow`}
        style={{
          width: "100%",
          backgroundImage: `url("${currentSlideshowImage?.url}")`,
          backgroundPosition: "center center",
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          position: "relative",
          height: "100%",
          display: "block",
          cursor: "pointer"
        }}>
      </div>
    } else if (hotspot.visibility_type === "image") {
      if (!isPresent(hotspot.hotspot_image?.url)) {
        console.log("hotspot", hotspot)
        return getErrorField("No image present!")
      }
      //let backgroundImage = hovered && hotspot.hover_image?.url ? `url("${isPresent(hotspot.hover_image?.url) ? hotspot.hover_image.url : hotspotSvg}")` : ` url("${hotspotSvg}"), url("${isPresent(hotspot.hotspot_image?.url) ? hotspot.hotspot_image.url : hotspotSvg}")`
      return <div
        className={`hotspot-image-inner-image`}
        style={{
          width: "100%",
          backgroundImage: backgroundImage,
          backgroundPosition: "center center",
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          position: "relative",
          height: "100%",
          display: "block",
          cursor: "pointer"
        }}>
      </div>
    } else if (hotspot.visibility_type === "hidden") {
      return <div
        className={`hotspot-image-inner-hidden`}
        style={{
          width: "100%",
          backgroundPosition: "center center",
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          position: "relative",
          height: "100%",
          display: "block",
          cursor: "pointer"
        }}>
      </div>
    }

    //let backgroundImage = hovered && hotspot.hover_image?.url ? `url("${isPresent(hotspot.hover_image?.url) ? hotspot.hover_image.url : hotspotSvg}")` : ` url("${hotspotSvg}"), url("${isPresent(hotspot.hotspot_image?.url) ? hotspot.hotspot_image.url : hotspotSvg}")`
    return internetExplorerRipple
  }

  const handleHotspotClick = () => {
    if (isBoothEditor || !(hotspot.visibility_type === "inline_html" && hotspot.data.hotspot_inline_html)) {
      onHotspotClick(hotspot, currentSlideshowImage, hotspotConfig);
    }
  }

  const mobileOnly = hotspot.data?.device_visibility === "mobile_only"
  const desktopOnly = hotspot.data?.device_visibility === "desktop_only"

  if (!isBoothEditor && isMobileByMediaQuery && desktopOnly) {
    return null
  }

  if (!isBoothEditor && !isMobileByMediaQuery && mobileOnly) {
    return null
  }

  try {
    return <>
      {/*
          onMouseOver={() => setHoveredHotspotId(hotspot.id)}
          onMouseOut={() => setHoveredHotspotId(null)}
          */}
      {isMobileByMediaQuery && useMobileHotspots ?
        <div className={"hotspot-mobile"} key={hotspot.id + String(currentSlideshowImage?.id)}>
          <div
            ref={(ref) => {
              refsArray.current["image_" + hotspot.id] = ref
            }}
            onClick={handleHotspotClick}
            key={"hotspot" + hotspot.id}
            id={`hotspot-mobile-${hotspot.id}`}
            className={classNames("imgHotspot", `image-map-${hotspot.image_map_id}`, {dotted: dotted})}
            style={(showHiddenHotspots || hotspot.kind !== "hidden") ? {
              position: "relative"
            } : {
              display: "none"
            }}>
            <div className="mobile-content">
              {getHotspotMobileContent()}
            </div>
          </div>
        </div>
        :

        <div className="hotspot-desktop">
          <div key={hotspot.id + String(currentSlideshowImage?.id)}>
            {/*              onMouseEnter={() => { hoverHotspot(hotspot.id)}}
              onMouseLeave={() => { hoverHotspot(null)}}
*/}
            <div
              ref={(ref) => {
                refsArray.current["image_" + hotspot.id] = ref
              }}
              onClick={handleHotspotClick}
              key={"hotspot" + hotspot.id}
              id={`hotspot-desktop-${hotspot.id}`}
              onMouseEnter={() => {
                setHoveredHotspotId ? setHoveredHotspotId(hotspot.id) : null
              }}
              onMouseLeave={() => {
                setHoveredHotspotId ? setHoveredHotspotId(null) : null
              }}
              className={classNames(`imgHotspot hotspot-config-identifier-${hotspotConfig.identifier || "undefined"}`, `image-map-${hotspot.image_map_id}`, {dotted: dotted})}
              style={elementDetails[hotspot.id] && (showHiddenHotspots || hotspot.kind !== "hidden") ? {
                position: "absolute",
                left: elementDetails[hotspot.id].left,
                top: elementDetails[hotspot.id].top,
                width: elementDetails[hotspot.id].width,
                height: elementDetails[hotspot.id].height,
              } : {
                display: "none"
              }}>

              {!isInternetExplorer && getHotspotVisual()}
              {isInternetExplorer && getInternetExplorerHotspotVisual()}
              {dotted &&
              <div className="handler pointer" style={{
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 999,
                padding: "1px 2px",
                backgroundColor: "rgba(255,255,255,0.8)"
              }}>
                <i className="fal fa-pen-square d-block"></i>
              </div>
              }
            </div>
          </div>
        </div>
      }
    </>
  } catch (ex) {
    console.error(ex)
    return <div className="alert alert-danger">Sorry, an error occured: {ex.message}</div>
  }

}
